import { Banner, BannerDescription } from '@wartek-id/banner'
import { Text } from '@wartek-id/text-v1'

import type { FC } from 'react'

type BannerDinasProps = {}

const BannerDinas: FC<BannerDinasProps> = ({}) => {
  return (
    <Banner
      title="Terima kasih sudah menyelesaikan periode ini!"
      type="success"
      closable={false}
      className="p-4 mt-8 print:!hidden"
    >
      <BannerDescription>
        <Text variant="body">
          Predikat Kinerja sudah ditetapkan oleh Dinas Pendidikan berdasarkan
          rekomendasi dari Tim Kerja (Pengawas Sekolah).
        </Text>
      </BannerDescription>
    </Banner>
  )
}

export default BannerDinas
